var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowerDoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_55)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0408 23V26.4237C48.4908 26.3429 48.9533 26.2914 49.4286 26.2914C49.9038 26.2914 50.3664 26.3429 50.8163 26.4237V23H48.0408ZM49.4286 27.2318C46.373 27.2318 43.8179 29.2412 43.1403 31.9339H55.7168C55.0392 29.2412 52.4842 27.2318 49.4286 27.2318ZM42.4898 32.8743C41.7255 32.8743 41.1021 33.508 41.1021 34.2849C41.1021 35.0618 41.7255 35.6955 42.4898 35.6955H56.3674C57.1317 35.6955 57.7551 35.0618 57.7551 34.2849C57.7551 33.508 57.1317 32.8743 56.3674 32.8743H42.4898ZM45.7279 37.1061C45.2165 37.1061 44.8027 37.5267 44.8027 38.0465C44.8027 38.5663 45.2165 38.9869 45.7279 38.9869C46.2393 38.9869 46.6531 38.5663 46.6531 38.0465C46.6531 37.5267 46.2393 37.1061 45.7279 37.1061ZM49.4286 37.1061C48.9172 37.1061 48.5034 37.5267 48.5034 38.0465C48.5034 38.5663 48.9172 38.9869 49.4286 38.9869C49.94 38.9869 50.3538 38.5663 50.3538 38.0465C50.3538 37.5267 49.94 37.1061 49.4286 37.1061ZM53.1293 37.1061C52.6179 37.1061 52.2041 37.5267 52.2041 38.0465C52.2041 38.5663 52.6179 38.9869 53.1293 38.9869C53.6406 38.9869 54.0544 38.5663 54.0544 38.0465C54.0544 37.5267 53.6406 37.1061 53.1293 37.1061ZM43.8776 40.8678C43.3662 40.8678 42.9524 41.2884 42.9524 41.8082C42.9524 42.328 43.3662 42.7486 43.8776 42.7486C44.3889 42.7486 44.8027 42.328 44.8027 41.8082C44.8027 41.2884 44.3889 40.8678 43.8776 40.8678ZM47.5782 40.8678C47.0669 40.8678 46.6531 41.2884 46.6531 41.8082C46.6531 42.328 47.0669 42.7486 47.5782 42.7486C48.0896 42.7486 48.5034 42.328 48.5034 41.8082C48.5034 41.2884 48.0896 40.8678 47.5782 40.8678ZM51.2789 40.8678C50.7675 40.8678 50.3538 41.2884 50.3538 41.8082C50.3538 42.328 50.7675 42.7486 51.2789 42.7486C51.7903 42.7486 52.2041 42.328 52.2041 41.8082C52.2041 41.2884 51.7903 40.8678 51.2789 40.8678ZM54.9796 40.8678C54.4682 40.8678 54.0544 41.2884 54.0544 41.8082C54.0544 42.328 54.4682 42.7486 54.9796 42.7486C55.491 42.7486 55.9048 42.328 55.9048 41.8082C55.9048 41.2884 55.491 40.8678 54.9796 40.8678ZM42.0272 44.6294C41.5158 44.6294 41.1021 45.05 41.1021 45.5698C41.1021 46.0896 41.5158 46.5102 42.0272 46.5102C42.5386 46.5102 42.9524 46.0896 42.9524 45.5698C42.9524 45.05 42.5386 44.6294 42.0272 44.6294ZM45.7279 44.6294C45.2165 44.6294 44.8027 45.05 44.8027 45.5698C44.8027 46.0896 45.2165 46.5102 45.7279 46.5102C46.2393 46.5102 46.6531 46.0896 46.6531 45.5698C46.6531 45.05 46.2393 44.6294 45.7279 44.6294ZM49.4286 44.6294C48.9172 44.6294 48.5034 45.05 48.5034 45.5698C48.5034 46.0896 48.9172 46.5102 49.4286 46.5102C49.94 46.5102 50.3538 46.0896 50.3538 45.5698C50.3538 45.05 49.94 44.6294 49.4286 44.6294ZM53.1293 44.6294C52.6179 44.6294 52.2041 45.05 52.2041 45.5698C52.2041 46.0896 52.6179 46.5102 53.1293 46.5102C53.6406 46.5102 54.0544 46.0896 54.0544 45.5698C54.0544 45.05 53.6406 44.6294 53.1293 44.6294ZM56.8299 44.6294C56.3186 44.6294 55.9048 45.05 55.9048 45.5698C55.9048 46.0896 56.3186 46.5102 56.8299 46.5102C57.3413 46.5102 57.7551 46.0896 57.7551 45.5698C57.7551 45.05 57.3413 44.6294 56.8299 44.6294Z",
    fill: "#393184"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 44.2145V71.2144C64 72.2809 63.1315 73.143 62.0571 73.143H56.2286V69.2859H60.1143V46.1431H56.2286V42.286H62.0571C63.1315 42.286 64 43.148 64 44.2145ZM36.3298 42.3438L51.8727 38.4867C52.4497 38.3421 53.0656 38.4713 53.5377 38.8377C54.0098 39.2041 54.2857 39.7634 54.2857 40.3574V75.0716C54.2857 75.6656 54.0098 76.2268 53.5377 76.5913C53.1919 76.8594 52.7722 77.0001 52.3429 77.0001C52.1855 77.0001 52.0281 76.9809 51.8727 76.9423L36.3298 73.0852C35.4633 72.8692 34.8571 72.0997 34.8571 71.2144V44.2145C34.8571 43.3293 35.4633 42.5598 36.3298 42.3438ZM44.5714 58.0771C44.5714 58.9623 45.1795 59.7318 46.0441 59.9478C47.2701 60.2525 48.4571 59.3326 48.4571 58.0771V57.35C48.4571 56.0964 47.2701 55.1746 46.0441 55.4793C45.1776 55.6953 44.5714 56.4667 44.5714 57.3519V58.0771Z",
    fill: "url(#paint1_linear_1062_55)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 44.2145V71.2144C64 72.2809 63.1315 73.143 62.0571 73.143H56.2286V69.2859H60.1143V46.1431H56.2286V42.286H62.0571C63.1315 42.286 64 43.148 64 44.2145ZM36.3298 42.3438L51.8727 38.4867C52.4497 38.3421 53.0656 38.4713 53.5377 38.8377C54.0098 39.2041 54.2857 39.7634 54.2857 40.3574V75.0716C54.2857 75.6656 54.0098 76.2268 53.5377 76.5913C53.1919 76.8594 52.7722 77.0001 52.3429 77.0001C52.1855 77.0001 52.0281 76.9809 51.8727 76.9423L36.3298 73.0852C35.4633 72.8692 34.8571 72.0997 34.8571 71.2144V44.2145C34.8571 43.3293 35.4633 42.5598 36.3298 42.3438ZM44.5714 58.0771C44.5714 58.9623 45.1795 59.7318 46.0441 59.9478C47.2701 60.2525 48.4571 59.3326 48.4571 58.0771V57.35C48.4571 56.0964 47.2701 55.1746 46.0441 55.4793C45.1776 55.6953 44.5714 56.4667 44.5714 57.3519V58.0771Z",
    stroke: "url(#paint2_linear_1062_55)",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_55",
    x: 32.7069,
    y: 21.1,
    width: 33.4431,
    height: 58.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_55",
    x: 32.7069,
    y: 36.2787,
    width: 33.4431,
    height: 42.8713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_55",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_55",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_55",
    x1: 60.8814,
    y1: 41.9874,
    x2: 26.2868,
    y2: 55.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_55",
    x1: 47,
    y1: 44.8573,
    x2: 29.8559,
    y2: 75.0817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerDoors);
export default __webpack_public_path__ + "static/media/shower-doors.2daca8a28303ef1c5b2838bc89959f89.svg";
export { ForwardRef as ReactComponent };